module.exports = __webpack_public_path__ + "static/media/no-resuts.97ed2726.svg";